import { LocalizeRouterService } from 'localize-router';
import { map } from 'rxjs/operators';
import { ApiService } from '../_services/api.service';
import * as i0 from "@angular/core";
import * as i1 from "../_services/api.service";
import * as i2 from "localize-router/src/localize-router.service";
var InstallatoriResolver = /** @class */ (function () {
    function InstallatoriResolver(api, localize) {
        this.api = api;
        this.localize = localize;
    }
    InstallatoriResolver.prototype.resolve = function (route) {
        return this.api.searchFornitori({ cdLingua: this.localize.parser.currentLang.toUpperCase() }).pipe(map(function (res) { return res.responses; }));
    };
    /** @nocollapse */ InstallatoriResolver.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function InstallatoriResolver_Factory() { return new InstallatoriResolver(i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.LocalizeRouterService)); }, token: InstallatoriResolver, providedIn: "root" });
    return InstallatoriResolver;
}());
export { InstallatoriResolver };
